import React, { useEffect, useState } from "react";
import {
  Navbar,
  Container,
  Offcanvas,
  Nav,
  Button,
  Modal,
  Dropdown,
} from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../../assets/images/logobb.webp";
import logoicon from "../../assets/images/logo-dashboard.png";
import userdefault from "../../assets/images/userdefault.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTachometerAlt,
  faUser,
  faRightFromBracket,
  faBell,
  faBriefcase,
  faUserTie,
  faCreditCard,
  faListAlt,
  faListCheck,
  faCrown,
} from "@fortawesome/free-solid-svg-icons";
import { auth } from "../../helper/Utility";
import { useGetMetaInfoMutation } from "../../features/front/FrontAPI";
import {
  useGetNotificationsQuery,
  useReadAllNotificationMutation,
  useReadNotificationMutation,
} from "../../features/common/CommonAPI";
import { CheckCircleOutlined, MarkChatUnread } from "@mui/icons-material";
import { Avatar, IconButton, Tooltip } from "@mui/material";
import { useDispatch } from "react-redux";
import { AgencyAPI } from "../../features/AgencyAPI";

const Header = () => {
  const [open, setOpen] = useState(false);
  const [showRoleModal, setShowRoleModal] = useState(false);
  const [selectedRole, setSelectedRole] = useState("");
  const [showNotifications, setShowNotifications] = useState(false);
  const authData = auth("user");
  const navigate = useNavigate();

  const [getMetaInfo] = useGetMetaInfoMutation();
  const [readNotification] = useReadNotificationMutation();
  const [readAllNotification] = useReadAllNotificationMutation();

  // Fetch notifications
  const { data: notifications, refetch } = useGetNotificationsQuery(
    { page: 1, perPage: 5 },
    {
      skip: !authData?.token,
      refetchOnMountOrArgChange: true,
      refetchOnFocus: true,
    },
  );

  const pathname = useLocation().pathname.replace(/^\/+/, "");

  const getMetaInfoFun = async () => {
    try {
      const params = { route: pathname ? pathname : "home" };
      const res = await getMetaInfo(params).unwrap();
      const info = res?.data;
      if (info?.metaTitle) {
        document.title = info.metaTitle;
      }
      if (info?.metaDescription) {
        const metaDescription = document.querySelector(
          "meta[name='description']",
        );
        if (metaDescription) {
          metaDescription.setAttribute("content", info.metaDescription);
        } else {
          const meta = document.createElement("meta");
          meta.name = "description";
          meta.content = info.metaDescription;
          document.head.appendChild(meta);
        }
      }
      if (info?.keywords) {
        let metaKeywords = document.querySelector("meta[name='keywords']");
        if (metaKeywords) {
          metaKeywords.setAttribute("content", info.keywords);
        } else {
          metaKeywords = document.createElement("meta");
          metaKeywords.name = "keywords";
          metaKeywords.content = info.keywords;
          document.head.appendChild(metaKeywords);
        }
      }
    } catch (error) {
      console.error("Meta info fetch failed", error);
    }
  };

  useEffect(() => {
    getMetaInfoFun();
  }, []);

  const dispatch = useDispatch();
  const handleLogout = () => {
    localStorage.removeItem("user-secret");
    dispatch(AgencyAPI.util.resetApiState());
    navigate("/");
  };

  const handleSignUpClick = (e) => {
    e.preventDefault();
    setShowRoleModal(true);
  };

  const handleRoleSelect = (role) => {
    setSelectedRole(role);
  };

  const handleContinue = () => {
    if (selectedRole) {
      setShowRoleModal(false);
      navigate("/signUp", { state: { role: selectedRole } });
      setSelectedRole("");
    }
  };

  const handleCloseModal = () => {
    setShowRoleModal(false);
    setSelectedRole("");
  };

  const handleBellClick = () => {
    const willOpen = !showNotifications;
    setShowNotifications(willOpen);

    if (willOpen) {
      refetch();
    }
  };

  const handleNotificationClick = async (notification) => {
    if (!notification?.isRead) {
      await readNotification({ id: notification?._id }).unwrap();
      refetch();
    }
    setShowNotifications(false);
  };

  const handleReadAll = async () => {
    await readAllNotification().unwrap();
    refetch();
  };

  const timeAgo = (date) => {
    const seconds = Math.floor((new Date() - new Date(date)) / 1000);
    if (seconds < 60) return `${seconds}s ago`;
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `${minutes}m ago`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours}h ago`;
    const days = Math.floor(hours / 24);
    return `${days}d ago`;
  };

  return (
    <>
      <header>
        <Navbar bg="white" expand="xl" className="py-md-3 p-1">
          <Container className="p-0">
            <Link className="logo_company" to="/">
              <img
                src={logo}
                className="header_logo website"
                alt="Company Logo – Your Brand Name"
                title="Your Brand Name"
                loading="lazy"
                decoding="async"
                width="100%"
                height="50"
              />

              <img
                src={logo}
                className="header_logo mobile"
                alt="Company Logo – Your Brand Name"
                title="Your Brand Name"
                loading="lazy"
                decoding="async"
                width="100%"
                height="50"
              />
            </Link>
            {!authData?.token && (
              <Navbar.Toggle aria-controls="offcanvasNavbar" />
            )}
            <Navbar.Offcanvas
              id="offcanvasNavbar"
              aria-labelledby="offcanvasNavbarLabel"
              placement="end"
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title id="offcanvasNavbarLabel">
                  Menu
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                {!authData && (
                  <Nav className="m-auto menu_list ">
                    <Link className="nav-link" to="/">
                      Home
                    </Link>
                    <Link className="nav-link" to="/blogs">
                      Blogs
                    </Link>
                    <Link className="nav-link" to="/about-us">
                      About
                    </Link>
                    <Link className="nav-link" to="/contact-us">
                      Contact
                    </Link>
                  </Nav>
                )}
                {!authData?.token && (
                  <>
                    <div className="user_btn">
                      <Button
                        onClick={handleSignUpClick}
                        variant="outline-primary"
                        className="me-2 line-close-btn"
                      >
                        Sign Up
                      </Button>
                      <Button
                        as={Link}
                        to="/login"
                        variant="outline-primary"
                        className="login_in_btn btn btn-primary"
                      >
                        Login
                      </Button>
                    </div>
                  </>
                )}
              </Offcanvas.Body>
            </Navbar.Offcanvas>

            {authData && (
              <div className="d-flex mt-lg-0 align-items-center">
                {/* Notification Bell Dropdown */}
                <Dropdown
                  show={showNotifications}
                  onToggle={() => setShowNotifications(!showNotifications)}
                  className="me-1"
                >
                  <Dropdown.Toggle
                    variant="link"
                    id="notification-dropdown"
                    className="p-0 border-0 position-relative text-decoration-none me-2"
                    style={{
                      boxShadow: "none",
                      background: "transparent",
                      cursor: "pointer",
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faBell}
                      size="md"
                      onClick={handleBellClick}
                    />
                    {notifications?.totalUnreadResults > 0 && (
                      <span className="position-absolute p-1 top-0 start-100 translate-middle badge rounded-pill bg-danger">
                        {notifications.totalUnreadResults}
                      </span>
                    )}
                  </Dropdown.Toggle>

                  <Dropdown.Menu
                    className="new_notification_drop"
                    align="end"
                    style={{
                      width: "350px",
                      padding: "0",
                      borderRadius: "8px",
                      marginTop: "10px",
                    }}
                  >
                    <div
                      className="noti_headers"
                      style={{
                        padding: "12px 16px",
                        display: "flex",
                        justifyContent: "space-between",
                        borderBottom: "1px solid #eee",
                        fontWeight: "600",
                      }}
                    >
                      Notifications
                      <Tooltip title="Mark all as read">
                        <IconButton
                          color="success"
                          size="small"
                          onClick={handleReadAll}
                        >
                          <CheckCircleOutlined
                            style={{ fontSize: "1.15rem" }}
                          />
                        </IconButton>
                      </Tooltip>
                    </div>

                    {notifications?.data && notifications.data.length > 0 ? (
                      <>
                        {notifications.data.slice(0, 4).map((item) => (
                          <div
                            className="list_items"
                            key={item._id}
                            onClick={() => handleNotificationClick(item)}
                            style={{
                              padding: "10px 16px",
                              backgroundColor: "rgb(218, 239, 255)",
                              borderBottom: "1px solid #f0f0f0",
                              cursor: "pointer",
                              fontWeight: !item.isRead ? "600" : "400",
                            }}
                          >
                            <Avatar
                              sx={{
                                width: 28,
                                height: 28,
                                fontSize: "1rem",
                                color: "#1e90ff",
                                bgcolor: "#fff",
                              }}
                            >
                              <MarkChatUnread fontSize="small"></MarkChatUnread>
                            </Avatar>
                            <div className="lisnt_tiles">
                              <div style={{ fontSize: "14px", color: "#000" }}>
                                {item.message}
                              </div>
                              <div
                                style={{
                                  fontSize: "12px",
                                  color: "#888",
                                  marginTop: "2px",
                                }}
                              >
                                {timeAgo(item.createdAt)}
                              </div>
                            </div>
                          </div>
                        ))}
                        <div
                          onClick={() => {
                            navigate("/notifications");
                            setShowNotifications(true);
                          }}
                          style={{
                            padding: "10px",
                            textAlign: "center",
                            cursor: "pointer",
                            color: "#1890ff",
                            fontWeight: 600,
                          }}
                        >
                          View All
                        </div>
                      </>
                    ) : (
                      <div
                        style={{
                          padding: "20px",
                          textAlign: "center",
                          color: "#888",
                        }}
                      >
                        No notifications yet
                      </div>
                    )}
                  </Dropdown.Menu>
                </Dropdown>

                <div className="user_profile">
                  <div className="user_details text-end">
                    <p>{authData?.firstName}</p>
                    <p className="role_name m-0 text-capitalize">
                      {authData?.user_role}
                    </p>
                  </div>

                  <div
                    className="profile-menu-wrapper"
                    onMouseEnter={() => setOpen(true)}
                    onMouseLeave={() => setOpen(false)}
                  >
                    <div
                      className={`profile-circle ${open ? "active" : ""}`}
                      onClick={() => setOpen(!open)}
                    >
                      <img
                        src={authData?.avatar ? authData?.avatar : userdefault}
                        alt="Profile"
                        className="profile-img"
                        loading="lazy"
                      />
                    </div>

                    <div className={`menu-box ${open ? "show" : ""}`}>
                      <Link to="/dashboard" className="menu-item-link">
                        <FontAwesomeIcon
                          icon={faTachometerAlt}
                          className="me-2"
                        />
                        Dashboard
                      </Link>

                      <Link to="/profile" className="menu-item-link">
                        <FontAwesomeIcon icon={faUser} className="me-2" />
                        Profile
                      </Link>

                      <Link to="/notifications" className="menu-item-link">
                        <FontAwesomeIcon icon={faBell} className="me-2" />
                        Notifications
                      </Link>

                      {authData?.user_role === "employer" && (
                        <>
                          <Link
                            to="/payment-methods"
                            className="menu-item-link"
                          >
                            <FontAwesomeIcon
                              icon={faCreditCard}
                              className="me-2"
                            />
                            Payment Methods
                          </Link>

                          <Link
                            to="/subscription-plan"
                            className="menu-item-link"
                          >
                            <FontAwesomeIcon icon={faCrown} className="me-2" />
                            Membership Plan
                          </Link>

                          <Link to="/current-plan" className="menu-item-link">
                            <i class="fa-solid fa-credit-card"></i> Current Plan
                          </Link>
                        </>
                      )}

                      {(authData?.user_role === "affiliate" ||
                        authData?.user_role === "recruiter") && (
                        <>
                          <Link
                            to="/referred-employers"
                            className="menu-item-link"
                          >
                            <FontAwesomeIcon icon={faUser} className="me-2" />
                            Referred Employers
                          </Link>
                          {authData?.user_role === "affiliate" && (
                            <>
                              <Link
                                to="/referred-commissions"
                                className="menu-item-link"
                              >
                                <i class="fa-solid fa-credit-card"></i> Referred
                                Commissions
                              </Link>

                              <Link
                                to="/affiliate/payout"
                                className="menu-item-link"
                              >
                                <i class="fa-solid fa-credit-card"></i> Payout
                              </Link>
                            </>
                          )}
                        </>
                      )}

                      {authData?.user_role === "agency" && (
                        <>
                          <Link to="/recruiters" className="menu-item-link">
                            <FontAwesomeIcon icon={faUser} className="me-2" />
                            My Recruiters
                          </Link>

                          <Link
                            to="/referred-commissions"
                            className="menu-item-link"
                          >
                            <i class="fa-solid fa-credit-card"></i> Referred
                            Commissions
                          </Link>

                          <Link
                            to="/affiliate/payout"
                            className="menu-item-link"
                          >
                            <i class="fa-solid fa-credit-card"></i> Payout
                          </Link>
                        </>
                      )}

                      <Link
                        to="/"
                        className="menu-item-link"
                        onClick={() => handleLogout()}
                      >
                        <FontAwesomeIcon
                          icon={faRightFromBracket}
                          className="me-2"
                        />
                        Logout
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </Container>
        </Navbar>
      </header>

      {/* Role Selection Modal */}
      <Modal
        show={showRoleModal}
        onHide={handleCloseModal}
        centered
        className="role-selection-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title className="w-100 text-center">
            <h2 className="mb-0">Signup As</h2>
            <p className="text-muted small mb-0">
              Choose your account type to continue
            </p>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <div
            className={`role-option p-3 mb-3 border rounded d-flex align-items-center ${
              selectedRole === "employee" ? "border-primary bg-light" : ""
            }`}
            style={{ cursor: "pointer" }}
            onClick={() => handleRoleSelect("employee")}
          >
            <div className="icon-wrapper bg-light rounded-circle p-3 me-3">
              <FontAwesomeIcon
                icon={faUser}
                size="2x"
                className="text-secondary"
              />
            </div>
            <div>
              <h5 className="mb-1">Employee</h5>
            </div>
          </div>

          <div
            className={`role-option p-3 mb-3 border rounded d-flex align-items-center ${
              selectedRole === "employer" ? "border-primary bg-light" : ""
            }`}
            style={{ cursor: "pointer" }}
            onClick={() => handleRoleSelect("employer")}
          >
            <div className="icon-wrapper bg-light rounded-circle p-3 me-3">
              <FontAwesomeIcon
                icon={faBriefcase}
                size="2x"
                className="text-secondary"
              />
            </div>
            <div>
              <h5 className="mb-1">Employer</h5>
            </div>
          </div>

          <div
            className={`role-option p-3 mb-3 border rounded d-flex align-items-center ${
              selectedRole === "affiliate" ? "border-primary bg-light" : ""
            }`}
            style={{ cursor: "pointer" }}
            onClick={() => handleRoleSelect("affiliate")}
          >
            <div className="icon-wrapper bg-light rounded-circle p-3 me-3">
              <FontAwesomeIcon
                icon={faUser}
                size="2x"
                className="text-secondary"
              />
            </div>
            <div>
              <h5 className="mb-1">Affiliate</h5>
            </div>
          </div>

          <div
            className={`role-option p-3 mb-3 border rounded d-flex align-items-center ${
              selectedRole === "agency" ? "border-primary bg-light" : ""
            }`}
            style={{ cursor: "pointer" }}
            onClick={() => handleRoleSelect("agency")}
          >
            <div className="icon-wrapper bg-light rounded-circle p-3 me-3">
              <FontAwesomeIcon
                icon={faBriefcase}
                size="2x"
                className="text-secondary"
              />
            </div>
            <div>
              <h5 className="mb-1">Agency</h5>
            </div>
          </div>

          <Button
            variant="primary"
            className="w-100 mt-3"
            size="lg"
            onClick={handleContinue}
            disabled={!selectedRole}
          >
            Continue
          </Button>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Header;
